import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useStarShop } from '../../../hooks';
import { func_animation } from '../../../utils/utilityEtc';

function StarView({ stgNm }) {
  const location = useLocation();
  const { isSave, setSave, starSaveUpAPICall } = useStarShop();

  useEffect(() => {
    if (isSave) func_animation('twinkle', 'starshop_img_eff', true);

    setTimeout(() => {
      setSave(false);
    }, 3000);
  }, [isSave]);

  useEffect(() => {
    const { state } = location;
    if (state.isCompleteAnsweringQuestions) starSaveUpAPICall(stgNm);
  }, [location]);

  return (
    <React.Fragment>
      {
        isSave && (
          <div className="lp-wrap lp-middle opa_08">
            <div className="star_done">
              <div className="light"><img src={`${process.env.PUBLIC_URL}/static/images/common/-g-starshop_img_light.svg`} alt="" /></div>
              <div className="star_cont">
                <div className="star"><img src={`${process.env.PUBLIC_URL}/static/images/common/starshop_img_star.svg`} alt="" /></div>
                <div className="tit">오늘 첫 학습 완료!</div>
                <div className="num">20</div>
              </div>
              <div className="twinkle">
                <div className="anim-wrap" id="twinkle"></div>
              </div>
            </div>
          </div>
        )
      }
    </React.Fragment>
  );
}

export default StarView;